import Repository from './Repository'

const action = 'bid'

export default {
  getRegistryEmailLog(id) {
    return Repository.get(`load-day/registry_email_log?day_id=${id}`)
  },
  addRegistryToBid(data) {
    return Repository.post(`${action}/registry-fields`, data)
  },
  checkRegistryFields(data) {
    return Repository.post(`${action}/check-registry-fields`, data)
  },
  getRegistry(id) {
    return Repository.get(`${action}/get-registry-fields?bid_id=${id}
`)
  },
}
